<template>
    <div>
        <!--class="grid with-grid-lines page--light is-chrome"-->
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
        <div style="padding-left:10%;margin-top:5%">
            <!-- https://www.zeleris.com/como-funciona-el-envio.aspx > vista -->
            <div class="module module_services grid inner_grid">
                <div class="module_container">
                    <ul>
                        <li>
                            <p class="text--s">
                                <v-icon>mdi-minus</v-icon>
                                <a target="_blank" href="/doc/CondicionesGeneralesServicioTecnico-Particulares.pdf" style="font-family: Heebo; font-weight: normal">Condiciones Generales para Particulares</a>
                            </p>
                        </li>
                        <li>
                            <p class="text--s">
                                <v-icon>mdi-minus</v-icon>
                                <a target="_blank" href="/doc/CondicionesGeneralesServicioTecnicoZeleris-Empresas.pdf" style="font-family: Heebo; font-weight: normal">Condiciones Generales para Empresas</a>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
         </div>
            <!-- Para el futuro si hay varias agrupaciones de enlaces -->
            <!--<div class="module module_services grid inner_grid">
            <div class="module_container">
                <div class="items_list">
                    <div class="item">
                        <div class="text_block">
                            <h3 class="title--m">Condiciones Generales del servicio</h3>
                            <p class="text--s"></p>
                            <ul>
                                <li>
                                    <p class="text--s">
                                        <v-icon>mdi-minus</v-icon>
                                        <a target="_blank" href="/doc/CondicionesGeneralesServicioTecnicoZeleris_ParticularSuscrito.pdf">Condiciones Generales para Particulares Suscritos</a>
                                    </p>
                                </li>
                                <li>
                                    <p class="text--s">
                                        <v-icon>mdi-minus</v-icon>
                                        <a target="_blank" href="/doc/CondicionesGeneralesServicioTecnicoZeleris_EmpresaRegistrada.pdf">Condiciones Generales para Empresas Registradas</a>
                                    </p>
                                </li>
                                <li>
                                    <p class="text--s">
                                        <v-icon>mdi-minus</v-icon>
                                        <a target="_blank" href="/doc/CondicionesGeneralesServicioTecnicoZeleris.pdf">Condiciones Generales para Particulares y Empresas Sin Registro</a>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

            <pie></pie>
        </div>
</template>

<script>
    export default {
        components: {
            encabezado: () => import("@/components/newEncabezado"),
            breadcrum: () => import("@/components/breadcrum"),
            pie: () => import('@/components/newPie')
        },
        data: () => ({
            cargando: false,
            name: 'Contratos',
            texto: 'A continuación podrás revisar las condiciones de los servicios que ofrecemos',
            titulo: 'Condiciones de servicio'
        }),
        methods: {

        },
        created() {
            //localstorage
        }
    }
</script>

<style>
    .module.module_services .items_list .item {
        width: calc(var(--grid_columns_size) * 3.5 - 0.1px) !important;
    }
</style>